export function loadGoogleMaps() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.google.maps));
      existingScript.addEventListener('error', (e) => reject(e));
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBYqqEMh9IfvSm2bryUK9iZ6uXTOnFMffA&libraries=places";
    script.async = true;
    script.defer = true;
    
    script.onload = () => resolve(window.google.maps);
    script.onerror = (e) => reject(e);
    
    document.head.appendChild(script);
  });
}
